import sstk, {ImagesApi, ContributorsApi} from "shutterstock-api";

const accessToken = `v2/Wno1VFVheXVaTWZGR2hXQWI0R0NKZnlKVUxVVjUwcEUvMjg0MTI1MTc1L2N1c3RvbWVyLzMvYkliUmFkQWZKeGM3YzExQ2RVYnpJZ2J6YXhrUnhlTGFseTQwa1NxbzR2dHcwRE5mNFQ5MHB1VjF1YzdURkU2a2ZjTkRMRXNKYlN3M2VIX2stbHZ5YktkTzJwV3B3d0JNY00xMlh6QnBUM1h3azRld1ptUUFfWXUyblNqb0NEejZub3VieXRjRC0wcHY5emt4WGpaZWRILUVNUHRDd1cxUmlXLW5RZGx5NGVVOFpMZ1pBNGtYd3JGVmx5cF91Q2xPYUZUbVE5T1F0dURadTZyTi1wVFQxUQ`;
sstk.setAccessToken(accessToken);

export const imagesApi = new ImagesApi();
export const contributorsApi = new ContributorsApi();
